/* eslint-disable react/no-array-index-key */
import React from "react";
import { useSelector } from "react-redux";
import HubCard from "./HubCard";
import HubStationIcon from "../../Common/Svgs/HubStationIcon";

const chunkArray = (array, size = 3) => {
  const chunks = [];

  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }

  return chunks;
};

const GridView = () => {
  const { hubEnergyBreakdown } = useSelector((state) => state.hubs);

  // dividing the array into group of 3
  const chunks = hubEnergyBreakdown.result.length
    ? chunkArray(hubEnergyBreakdown.result, 3)
    : [];

  return (
    <div className="bg-background-white w-full h-[calc(100vh-72px-70px-48px-112px-60px-40px)] overflow-y-scroll py-4 px-6 border-y border-light-grey">
      {chunks.length ? (
        chunks.map((chunk, index) => (
          <div
            key={index}
            className={`flex flex-row gap-x-6 ${index !== 0 ? "mt-6" : ""}`}
          >
            {chunk.map((hub, idx) => (
              <HubCard key={hub.id || idx} data={hub} />
            ))}
          </div>
        ))
      ) : (
        <div className="flex items-center justify-center gap-x-2 h-full">
          <div className="flex items-center justify-center h-full">
            <div className="w-9.5 h-9.5 bg-light-grey rounded-full flex items-center justify-center">
              <HubStationIcon size={16} className=" text-dark-grey-text" />
            </div>
          </div>

          <p className="font-light text-10 leading-3.75 font-poppins text-dark-grey-text">
            Nothing to show
          </p>
        </div>
      )}
    </div>
  );
};

export default GridView;
